export type Branding = {
  companyName: string | null;
  logoDataUrl: string | null;
  /** What Chat calls the personal assistant; Nivi when null. */
  assistantName: string | null;
  /** The assistant's icon as a PNG data URL; the standard icon when null. */
  assistantIconDataUrl: string | null;
};
export const DEFAULT_BRANDING: Branding = {
  companyName: null,
  logoDataUrl: null,
  assistantName: null,
  assistantIconDataUrl: null,
};
/** What Chat calls the personal assistant when Admin chose no name. */
export const DEFAULT_ASSISTANT_NAME = 'Nivi';
